export default {"src":"/_next/static/media/lifebuoy_40.c9b792d6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};